import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { URL_APP_BILLING } from "../../../data/URLs";
import { LocalStateAction } from "../../../models";

type UpgradeDialogProps = {
  showDialog: boolean;
  setShowDialog: LocalStateAction<boolean>;
};

const UpgradeDialog: FC<UpgradeDialogProps> = ({
  showDialog,
  setShowDialog,
}) => {
  const Navigate = useNavigate(); 

  return (
    <Dialog
      open={showDialog}
      onClose={() => setShowDialog(false)}
      aria-labelledby="delete-link-alert-title"
      aria-describedby="delete-link-alert-description"
    >
      <DialogTitle id="alert-dialog-title">Need your support</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          By paying a tiny amount, you can enjoy creating unlimited links.<br />
          ( Just $3.99 per month )
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setShowDialog(false)}>Cancel</Button>
        <Button
          onClick={() => {
            setShowDialog(false);
            Navigate(URL_APP_BILLING);
          }}
          autoFocus
        >
          Pay
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpgradeDialog;
